import { Col, Layout, Row } from 'antd'
import { Outlet } from 'react-router-dom'
import { LayoutFooter } from '../components/LayoutFooter'
import MainHeader from '../components/MainHeader'

const { Content } = Layout

export const HelpLayout: React.FC = () => {
  return (
    <Layout>
      <MainHeader />
      <Layout style={{ minHeight: 'calc(100vh - 64px)', marginTop: 64 }}>
        <Content>
          <Row className="container-row">
            <Col xs={24} className="px-4">
              <Outlet />
            </Col>
          </Row>
        </Content>
        <LayoutFooter />
      </Layout>
    </Layout>
  )
}
